export default __webpack_public_path__ + "static/media/ewc.771a4fb1.png";